export const LABEL_SETTINGS_QUERY_KEY = ['label-settings'] as const;
